import { FIELD_SKILLS_FRAMEWORK_IDS_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { useSelectedSkillsFrameworks } from "PFApp/hooks/activity_form/use_selected_skills_frameworks";
import { useWatch } from "react-hook-form";

export const useFormSelectedSkillsFrameworks = () => {
  const skillsFrameworksIds = useWatch({ name: FIELD_SKILLS_FRAMEWORK_IDS_KEY });

  return useSelectedSkillsFrameworks(skillsFrameworksIds);
};
